import { useAutoAddressCheck } from './hooks/useAutoAddressCheck';
import { useDisplayErrorForAvailabilityCheck } from 'hooks/useDisplayErrorForAvailabilityCheck';
import { LoadingContainer } from 'components/content/LoadingContainer/LoadingContainer';

export const AvailabilityCheckPage = () => {
    const { error } = useAutoAddressCheck();
    const displayError = useDisplayErrorForAvailabilityCheck(error);

    return displayError ? displayError : <LoadingContainer />;
};
